import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, CardHeader } from 'reactstrap';
import DataTable from '../../../../components/Common/DataTable';

/**
 * ProfileTabList
 * Componente reutilizável para exibir listas formatadas dentro das abas do Perfil do Aluno.
 * Encapsula o DataTable com um cabeçalho padronizado e Card estilizado.
 */
const ProfileTabList = ({
    title,
    description,
    icon,
    actionButton,
    columns,
    data = [],
    isLoading = false,
    emptyMessage = "Nenhum registro encontrado",
    emptySubMessage,
    keyField = "id"
}) => {
    return (
        <Card className="border-0 shadow-sm rounded-0 overflow-hidden mt-4">
            <CardHeader className="bg-white border-bottom p-4 d-flex justify-content-between align-items-center flex-wrap gap-3">
                <div className="d-flex align-items-center flex-grow-1">
                    {icon && (
                        <div className="avatar-sm me-3 flex-shrink-0">
                            <span className="avatar-title bg-primary-subtle text-primary rounded-circle font-size-22">
                                <i className={`mdi ${icon}`}></i>
                            </span>
                        </div>
                    )}
                    <div>
                        <h5 className="mb-1 fw-bold text-dark">{title}</h5>
                        {description && <p className="text-muted mb-0 font-size-13">{description}</p>}
                    </div>
                </div>
                
                {actionButton && (
                    <div className="flex-shrink-0">
                        {actionButton}
                    </div>
                )}
            </CardHeader>

            <CardBody className="p-0">
                <DataTable
                    columns={columns}
                    data={data}
                    isLoading={isLoading}
                    emptyMessage={emptyMessage}
                    emptySubMessage={emptySubMessage}
                    keyField={keyField}
                />
            </CardBody>
        </Card>
    );
};

ProfileTabList.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    icon: PropTypes.string,
    actionButton: PropTypes.node,
    columns: PropTypes.array.isRequired,
    data: PropTypes.array,
    isLoading: PropTypes.bool,
    emptyMessage: PropTypes.string,
    emptySubMessage: PropTypes.string,
    keyField: PropTypes.string
};

export default ProfileTabList;
